export default "__VITE_ASSET__S49kncqM__"